import * as Three from 'three';
import { CSS2DRenderer, CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer';
import EventEmitter from '../../../helpers/EventEmmiter';
import Magnify from './magnify';
const DetectRTC = require('detectrtc');
const cloneDeep = require('lodash/cloneDeep');

const styles = {
    colors: {
        grey: '#1e2124'
    }
};

const enumType = {
    measurementLine: "measurementLine",
    measurementLabel: "measurementLabel",
    measurementPoint: "measurementPoint",
    measurementCursor: "measurementCursor"
}

export const unit = {
    mm: {
        name: 'mm',
        coff: 10
    },
    // cm: {
    //     name: 'cm',
    //     coff: 1,
    // },
    m: {
        name: 'm',
        coff: 0.01,
        current: true
    },
    ft: {
        name: 'ft',
        coff: 0.032808399,
    }
}

export default class MeasurementTool extends EventEmitter {
    _ctrlDown = true;
    _lineId = 0;
    _line = Three.Line;
    _lines = [];
    _cursor = null;
    _drawingLine = false;
    _labels = {};
    _raycaster = new Three.Raycaster();
    _intersects = Three.Intersection;
    _measurementMouse = new Three.Vector2();
    _meshBasicMaterial = {
        side: Three.DoubleSide,
        opacity: 1,
        transparent: true,
        alphaTest : 0.5,
    }
    _wrapper = null;
    _unit = Object.values(unit).find(({current}) => current)
    _startFormat = `0.0${this._unit.name}`;
    _lineColor = {
        active: 0x00fc02,
        regular: 0xffffff,
    }
    _lastPoint = null;
    _prefixMeasurement = `e3-viewer-3dplan-measurement`;
    _active = `${this._prefixMeasurement}-active`;
    _press = false;
    _mouseMove = false;
    _group = null;
    _downPos = {};
    _insidelWall = [];

    constructor(objects, {wrapper, camera, scene3D, renderer, orbitControls}) {
       super();

       this._wrapper = wrapper;
       this._objects = objects;
       this._renderer = renderer;
       this._orbitControls = orbitControls;
       this._scene3D = scene3D;
       this._camera = camera;
       
       this._init();

       this._toogleFloorVisability(false);
       this._renderer.setClearAlpha(true);
       this._renderer.setClearColor(new Three.Color(styles.colors.grey), 0);
       this._wrapper.classList.add(this._active);
       this._initMeasurementMode(true);
       this._magnified();
    }

    setSize(width, height) { 
        this._width = width;
        this._height = height;
    }

    addLabelRenderer() {
        const labelRenderer = new CSS2DRenderer(); // Create a CSS2DRenderer
        // const labelRenderer = new CSS3DRenderer({ antialias: true });
        labelRenderer.setSize(this._width, this._height);
        labelRenderer.domElement.classList.add('css3d-object');
        labelRenderer.domElement.style.position = 'absolute';
        labelRenderer.domElement.style.top = '0px';
        labelRenderer.domElement.style.pointerEvents = 'none';

        return labelRenderer;
    }

    isObjectInFront(object1, object2, camera) {
        var raycaster1 = new Three.Raycaster();
        var raycaster2 = new Three.Raycaster();
        
        // Get the world positions of the objects
        var object1Position = new Three.Vector3();
        var object2Position = new Three.Vector3();
        object1.getWorldPosition(object1Position);
        object2.getWorldPosition(object2Position);
    
        // Set the ray origins to the object positions
        raycaster1.ray.origin.copy(object1Position);
        raycaster2.ray.origin.copy(object2Position);
    
        // Set the ray directions (e.g., casting along the negative z-axis)
        raycaster1.ray.direction.set(0, 0, -1);
        raycaster2.ray.direction.set(0, 0, -1);
    
        // Perform raycasting and check for intersections
        var intersects1 = raycaster1.intersectObject(object2);
        var intersects2 = raycaster2.intersectObject(object1);
    
        if (intersects1.length > 0) {
            return "Object 1 is in front of Object 2.";
        } else if (intersects2.length > 0) {
            return "Object 2 is in front of Object 1.";
        } else {
            return "The two objects do not overlap or intersect.";
        }
    }

    getObjectDepth(object, camera, depthRenderTarget) {
        var objectPosition = new Three.Vector3();
        object.getWorldPosition(objectPosition);
    
        var objectScreenPosition = objectPosition.clone().project(camera);
        var depthValue = depthRenderTarget.depthBuffer.getValue(objectScreenPosition.x, objectScreenPosition.y);
    
        return depthValue;
    }

    _init() {
        this._initListener();
    }

    toggleMode() {
        if(this._wrapper.classList.contains(this._active)){
            this._wrapper.classList.remove(this._active);
            this._initMeasurementMode(false);
        } else {
            this._wrapper.classList.add(this._active);
            this._initMeasurementMode(true);
        }
    }

    _initListener() {
        this._pointerUpEventBound = this._pointerUpEvent.bind(this);
        this._mousemoveEventBound = this._mousemoveEvent.bind(this);
        this._pointerMoveBound = this._pointerMove.bind(this);
        this._onPointerDownBound = this._onPointerDown.bind(this);

        this._renderer.domElement.addEventListener('mousemove', this._mousemoveEventBound);
        this._renderer.domElement.addEventListener('pointermove', this._pointerMoveBound);
        this._renderer.domElement.addEventListener('pointerup', this._pointerUpEventBound);
        this._renderer.domElement.addEventListener('pointerdown', this._onPointerDownBound);
    }

    _onPointerDown(event) {
        this._press = true;
        this._fireEvent('on.mouse.down', event)
        this._downPos = {
            x: event.x,
            y: event.y
        }
    }

    _pointerMove(event) {
        if(this._press) {
            this._fireEvent('on.mouse.move', event);
            this._mouseMove = true;
        }
    }

    _toogleFloorVisability(show) {
        this._objects.plan.children.forEach((obj) => {
            obj.visible = show;
        })
    }
    
    _initMeasurementMode(mode) {
        if(mode) {
            this._orbitControls.enabled = false;
            this._renderer.domElement.style.cursor = 'crosshair';
            this._drawingLine = false;
            this._wrapper.classList.remove('hidden');
        } else {
            this._orbitControls.enabled = true;
            this._renderer.domElement.style.cursor = 'pointer';

            if (this._drawingLine) {
                this._removeLastPoint();
                this._removeCursor();
            }

            this._fireEvent('render')
        }
    }

    closePolyline() {
        this._fireEvent('close.polyline', {})
        this._removeLastPoint();
        this._removeCursor();
        this._fireEvent('render')
    }

    _removeLastPoint () {
        this._drawingLine = false;
        this._group.remove(this._line);
        this._group.remove(this._labels[this._lineId]);
        this._lineId--;
    }
    
    _filterObjects() {
        return this._objects.plan.children.filter(({name}) => name !== 'teleport');
    }

    _snap({object, point}) {
        const intersectPoint = point;
        const {name} = object;

        if (this._lines.length > 0 && this._lastPoint?.object?.name === name) {
            const prevPoint = this._lines[this._lines.length - 1];
            const X = 'x';
            const Y = ['floor', 'ceiling'].includes(name)  ? 'z' : 'y';

            const deltaX = intersectPoint[X] - prevPoint[X];
            const deltaY = intersectPoint[Y] - prevPoint[Y];
           
            if (Math.abs(deltaX) > Math.abs(deltaY)) {
                intersectPoint[Y] = prevPoint[Y];
            } else {
                intersectPoint[X] = prevPoint[X];
            }
        }
    }

    _mousemoveEvent(event) {
        event.preventDefault();
        this._getMeasurementMouse(event);
        this._fireEvent('mousemove', this._measurementMouse);

        if (this._drawingLine) {
            this._raycaster.setFromCamera(this._measurementMouse, this._camera);
            this._intersects = this._raycaster.intersectObjects(this._filterObjects(), true);

            if (this._intersects.length > 0) {
                // const intersectPoint = this._intersects[0].point;

                this._updateLabelPosition(this._intersects[0]);
                // this._updateCursorPositions(intersectPoint);
                this._orientationLabelOnCamera();
                this._fireEvent('render');
                // this._directionCursor(this._objects.plan);
            }
        } 
    }

    _directionCursor(wall) {
        const blueAxis = this._cursor.children.find(({name})=> name==='blueAxis');

        blueAxis.rotation.z = 0; 

        if(!this.isObjectInside(wall, blueAxis)) {
            blueAxis.rotation.z = Math.PI; 
        } else {
            blueAxis.rotation.z = 0; 
        }
    }

    isObjectInside(container, object) {
        const containerBox = new Three.Box3();
        containerBox.setFromObject(container);

        const objectBox = new Three.Box3();
        objectBox.setFromObject(object);

        return containerBox.containsBox(objectBox);
    }

    calculateAngleBetweenObjectAndCamera(object, camera) {
        const tempVector = new Three.Vector3();
        const tempVector2 = new Three.Vector3();

        object.getWorldPosition(tempVector);
        camera.getWorldPosition(tempVector2);

        const direction = tempVector.clone().sub(tempVector2);
        const angle = camera.getWorldDirection(tempVector2).angleTo(direction);
        const degrees = Three.MathUtils.radToDeg(angle);
    
        return degrees;
    }

    calculateAngleBetweenObjects(obj1, obj2) {
        const direction = obj2.position.clone().sub(obj1.position);
        const angle = Math.atan2(direction.y, direction.x);
        const degrees = angle * (180 / Math.PI);
        
        return degrees;
    }
      
    _updateLabelPosition({ point: intersectPoint, object }) {
        const positions = this._line.geometry.attributes.position.array;
        const v0 = new Three.Vector3(
            positions[0],
            positions[1],
            positions[2]
        );
        const v1 = new Three.Vector3(
            intersectPoint.x,
            intersectPoint.y,
            intersectPoint.z
        );
    
        positions[3] = intersectPoint.x;
        positions[4] = intersectPoint.y;
        positions[5] = intersectPoint.z;
        this._line.geometry.attributes.position.needsUpdate = true;
        
        const distance = v0.distanceTo(v1);
    
        this._labels[this._lineId].element.innerText = (distance * this._unit.coff).toFixed(2) + this._unit.name;
        this._labels[this._lineId].position.lerpVectors(v0, v1, 0.5);
    }
    

    isActive() {
        return this._labels.length > 1;
    }

    _updateCursorPositions(intersectPoint) {
        if (!this._cursor) return ;

        this._cursor.position.copy(intersectPoint);
        this._cursor.rotation.copy(this._intersects[0].object.rotation);
        // this._cursor.geometry.copy(this._intersects[0].object.geometry);
        this._cursor.geometry.needsUpdate = true;
}

    _orientationLabelOnCamera() {
        const labels = this._labels;
        const camera = this._camera;
        const cameraDirection = new Three.Vector3();
        camera.getWorldDirection(cameraDirection);
    
        for (const key in labels) {
            if (labels.hasOwnProperty(key)) {
                const label = labels[key];
                const cameraPosition = this._camera.position.clone();
                label.lookAt(cameraPosition);
            }
        }
    }

    _isUserMove(event) {
        if(this._mouseMove && (this._downPos.x !== event.x || this._downPos.y !== event.y)){
            this._mouseMove = false;

            return true;
        }

        return false
    }

    _pointerUpEvent(event) {
        event.preventDefault();
        this._press = false;
        this._fireEvent('on.mouse.up')

        if(this._isUserMove(event)) return ;
        if(DetectRTC.isMobileDevice) this._getMeasurementMouse(event);

        this._raycaster.setFromCamera(this._measurementMouse, this._camera);
        this._intersects = this._raycaster.intersectObjects(this._filterObjects(), true);
        if (this._intersects.length > 0) {
            const intersectPoint = this._intersects[0].point;
            this._lines.push(intersectPoint);

            if (!this._drawingLine) {
                this._group = new Three.Group();
                this._group.name = `measurement_${this._groupCount}`;

                this._scene3D.add(this._group);
                this._createMeasurementShape();
                // this._addCursor();
                this._addPoint(this._intersects[0]);
                this._sendEvent('start');
            } else {
                this._updateLabelPosition(this._intersects[0]);
                this._closeLine();
                this._createMeasurementShape();
                this._orientationLabelOnCamera();
            }

            this._lastPoint = this._intersects[0];
        }

        this._fireEvent('render')
    }

    _getMeasurementMouse(event) {
        var rect = this._renderer.domElement.getBoundingClientRect();
        const normalizedMouse = new Three.Vector2();
        normalizedMouse.x = ((event.clientX - rect.left) / (rect.right - rect.left)) * 2 - 1;
        normalizedMouse.y = -((event.clientY - rect.top) / (rect.bottom - rect.top)) * 2 + 1;

        this._measurementMouse.x = normalizedMouse.x;
        this._measurementMouse.y = normalizedMouse.y;
    }
    
    _closeLine() { 
        const positions = this._line.geometry.attributes.position.array;
        const point = this._cursor?.position ||  this._intersects[0].point;
        positions[3] = point.x;
        positions[4] = point.y;
        positions[5] = point.z;
        this._line.geometry.attributes.position.needsUpdate = true;
        this._line.material.color.setHex(this._lineColor.regular);

        this._addPoint(this._intersects[0]);

        this._lineId++;
        this._drawingLine = false;
    }

    _createMeasurementShape() {
        const points = [];
        const point = this._cursor?.position || this._intersects[0].point;
        points.push(point);
        points.push(point.clone());
        this._line = this._create('line', points);
       
        this._group.add(this._line);

        this._labels[this._lineId] = this._create('label');
        this._group.add(this._labels[this._lineId]);
        this._drawingLine = true;
    }

    _addPoint(target) {
        const point = this._create('point', target);
        this._group.add(point);
        this._sendEvent('onAddPoint');
    }
       
    _sendEvent(type) {
        const pointCount = this._group?.children.filter(({name}) => name === enumType.measurementPoint).length || 0;
        this._fireEvent('on.add.point', {count: pointCount, type, drawingLine: this._drawingLine});
    }

    _addCursor() {
        if(DetectRTC.isMobileDevice) return ;

        this._cursor = this._create('cursor', {});

        this._group.add(this._cursor);
    }

    _magnified() {
        if(DetectRTC.isMobileDevice) return ;

        this._magniGlass = new Magnify(this._wrapper);

        this.on('on.mouse.down', () => {
            this._magniGlass.hide();
        })

        this.on('on.mouse.up', () => {
            this._magniGlass.show();
        })
    }

    _removeCursor() {
        if(this._group) {
            const shape = this._group.children.find(({name}) => name === enumType.measurementCursor);
            this._group.remove(shape);
        }

        this._cursor = null;
        this._lines = [];
        this._sendEvent('end');
    }

    _create(type, options) {
        let shape = null;

        switch (type){
            case 'line':
                shape = this._lineShape(options);
            break;
            case 'label':
                shape = this._labelShape(options);
                break;
            case 'point':
                shape = this._pointShape(options);
                break;
            case 'cursor':
                shape = this._cursorShape(options);
                break;
            default:
                
        }

        return shape;
    }
   
    _cursorShape(point) {
        let newPoint = new Three.Mesh();

        // Red Axis
        let redAxis = new Three.ArrowHelper(new Three.Vector3(1, 0, 0), new Three.Vector3(0, 0, 0), 100, 0xff0000);
        redAxis.name="redAxis";
        newPoint.add(redAxis);

        // Green Axis
        let greenAxis = new Three.ArrowHelper(new Three.Vector3(0, 1, 0), new Three.Vector3(0, 0, 0), 100, 0x00ff00);
        greenAxis.name="greenAxis";
        greenAxis.rotation.z = Math.PI; // Rotate by 180 degrees
        newPoint.add(greenAxis);

        // Blue Axis
        let blueAxis = new Three.ArrowHelper(new Three.Vector3(0, 0, 1), new Three.Vector3(0, 0, 0), 100, 0x0000ff);
        blueAxis.name="blueAxis";
        newPoint.add(blueAxis);

        // Create a 2D square using four line segments
        const squareSize = 10; // Adjust the size as needed

        const squareMaterial = new Three.LineBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0.5 }); // Make the square lines transparent

        // Create the square by connecting the four line segments
        const squareGeometry = new Three.BufferGeometry().setFromPoints([
            new Three.Vector3(-squareSize / 2, -squareSize / 2, 0),
            new Three.Vector3(squareSize / 2, -squareSize / 2, 0),
            new Three.Vector3(squareSize / 2, -squareSize / 2, 0),
            new Three.Vector3(squareSize / 2, squareSize / 2, 0),
            new Three.Vector3(squareSize / 2, squareSize / 2, 0),
            new Three.Vector3(-squareSize / 2, squareSize / 2, 0),
            new Three.Vector3(-squareSize / 2, squareSize / 2, 0),
            new Three.Vector3(-squareSize / 2, -squareSize / 2, 0),
        ]);

        const square = new Three.Line(squareGeometry, squareMaterial);
        square.name='measurementLine';
        newPoint.add(square);

        // Create a white sphere with a red border
        const sphereGeometry = new Three.SphereGeometry(2, 32, 32);
        const sphereMaterial = new Three.MeshBasicMaterial({ color: 0xffffff });
        const sphere = new Three.Mesh(sphereGeometry, sphereMaterial);

        // Create a red border for the sphere
        const sphereBorderGeometry = new Three.SphereGeometry(2.1, 32, 32);
        const sphereBorderMaterial = new Three.MeshBasicMaterial({ color: 0xff0000 });
        const sphereBorder = new Three.Mesh(sphereBorderGeometry, sphereBorderMaterial);
       
        newPoint.name='measurementSphere';
        newPoint.add(sphere);
        // newPoint.add(sphereBorder);

        newPoint.position.copy(point);
        newPoint.renderOrder = 1;
        newPoint.name = enumType.measurementCursor;

        return newPoint;
    }

    _pointShape({point, object, face}) {
        const n = new Three.Vector3();
        n.copy(face.normal);
        n.transformDirection(object.matrixWorld);

        const geometry = new Three.CircleGeometry( 4, 16 ); 
        const pointMaterial = new Three.MeshBasicMaterial({ 
            ...this._meshBasicMaterial,
            color: 0xff0000,
            depthTest: false
         }); 
        const newPoint = new Three.Mesh( geometry, pointMaterial );
        newPoint.lookAt(n);
        newPoint.position.copy(point);
        // newPoint.rotation.copy(object.rotation);
        newPoint.position.addScaledVector(n, 0.1);
        newPoint.geometry.needsUpdate = true;
        newPoint.renderOrder = 1;
        newPoint.name = enumType.measurementPoint;

        return newPoint;
    }

    _lineShape(points) {
        const geometry = new Three.BufferGeometry().setFromPoints(
            points
        );
        const line = new Three.LineSegments(
            geometry,
            new Three.LineDashedMaterial({
                ...this._meshBasicMaterial, 
                color: this._lineColor.active,
                linewidth: 10,
                dashSize: 2,
	            gapSize: 2,
                dash: true,
                depthTest: false
            })
        );
        line.frustumCulled = false;
        line.name = enumType.measurementLine;
        line.renderOrder = 0;

        return line;
    }

    _groupCount () {
        return this._scene3D.children.filter(({type}) => type==='Group').length;
    }

    _labelShape() {
        const element = document.createElement('div');
        element.className = enumType.measurementLabel;
        element.innerText = this._startFormat;
        element.style.backgroundColor = 'white';
        element.style.color = 'black';
        
        const label = new CSS2DObject(element);
        label.position.copy(this._intersects[0].point);
        label.name = enumType.measurementLabel;

        return label;
    }
    
    destroyGroups() {
        const keys = Object.keys(enumType);
        const shapes = [];

        for(let i in this._scene3D.children){
            const shape = this._scene3D.children[i];

            if(shape.type === 'Group') {
                shapes.push(shape);
            }
        }
        shapes.forEach((shape) => this._scene3D.remove(shape));
        this._fireEvent('render');
        this._sendEvent('start');
    }

    removeShapes() {
        const keys = Object.keys(enumType);
        const shapes = [];

        for(let i in this._group.children){
            const shape = this._group.children[i];

            if(keys.includes(shape.name)) {
                shapes.push(shape);
            }
        }
        shapes.forEach((shape) => this._group.remove(shape));
        this._fireEvent('render');
        this._sendEvent('start');
    }

    setUnit(e) {
        const oldUnit = cloneDeep(this._unit);
        this._unit = Object.values(unit).find((data) => data.coff == e.value);

        const labels = this._labels;
    
        for (const key in labels) {
            if (labels.hasOwnProperty(key)) {
                const label = labels[key];
                const inputString = label.element.innerText;
                let {number} = this._parseUnit(inputString);
                const value = number / oldUnit.coff * this._unit.coff;

                label.element.innerText = `${value.toFixed(2)}${this._unit.name}`;
            }
        }
    }

    _parseUnit(inputString){
        const regex = /^(\d+(\.\d+)?)\s*([a-zA-Z]+)$/;
        const match = inputString.match(regex);
        const number = parseFloat(match[1]);
        const unit = match[3];

        return {number, unit};
    }

    destroy() {
        this._renderer.domElement.removeEventListener('pointerup', this._pointerUpEventBound);
        this._renderer.domElement.removeEventListener('mousemove', this._mousemoveEventBound);
        this._renderer.domElement.removeEventListener('pointerdown', this._onPointerDownBound);
        this._renderer.domElement.removeEventListener('pointermove', this._pointerMoveBound);

        this.destroyGroups();
        this._labels = {};
        this._line = null;

        if(this._magniGlass) {
            this._magniGlass.destroy();
        }   
    }
}